import { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogContent, Divider, IconButton, Link, Stack, Typography, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { FormattedMessage, useIntl } from 'react-intl';
import useApi from 'hooks/useApi';
import { WEB_VERSION } from 'store/constant';
import insightLogo from 'assets/images/signup-logo.svg';

const envbasename = import.meta.env.VITE_APP_BASE_NAME || '/mui';
const basename = envbasename === '/' ? '' : envbasename;
const AboutDialog = ({ open, onClose }) => {
  const theme = useTheme();
  const intl = useIntl();
  const [cloudVersion, setCloudVersion] = useState('');

  useEffect(() => {
    if (open) {
      fetchCloudVersion();
    }
  }, [open]);

  const fetchCloudVersion = async () => {
    try {
      const data = await useApi('GET_CLOUD_VERSION', {}, '', []);
      if (data?.NetgearInsightCloud) {
        setCloudVersion(data.NetgearInsightCloud);
      }
    } catch (error) {
      console.error('Error fetching cloud version:', error);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { borderRadius: 2, width: 510, maxWidth: '90vw' }
      }}
    >
      <IconButton
        aria-label={intl.formatMessage({ id: 'close', defaultMessage: 'Close' })}
        onClick={onClose}
        sx={{ position: 'absolute', right: 8, top: 8, color: theme.palette.grey[500] }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ textAlign: 'center', py: 5, px: 3 }}>
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
          <img src={insightLogo} alt="NETGEAR Insight" style={{ height: 55 }} />
        </Box>

        <Stack
          direction="row"
          spacing={1.5}
          justifyContent="center"
          alignItems="center"
          divider={<Divider orientation="vertical" flexItem />}
          sx={{ mb: 3 }}
        >
          <Typography color="text.secondary" sx={{ fontSize: 13 }}>
            <FormattedMessage
              id="aboutWebPortalVersion"
              defaultMessage="Web Portal Version : {version}"
              values={{ version: WEB_VERSION }}
            />
          </Typography>
          <Typography color="text.secondary" sx={{ fontSize: 13 }}>
            <FormattedMessage id="aboutCloudVersion" defaultMessage="Cloud Version : {version}" values={{ version: cloudVersion || '—' }} />
          </Typography>
        </Stack>

        <Stack direction="row" spacing={3} justifyContent="center" sx={{ mb: 2 }}>
          <Link
            component="button"
            onClick={() => window.open(`${basename}/terms`, '_blank')}
            underline="always"
            sx={{ fontSize: 13, color: theme.palette.text.primary, textDecorationColor: theme.palette.text.primary, cursor: 'pointer' }}
          >
            <FormattedMessage id="termsConditions" defaultMessage="Terms and Conditions" />
          </Link>
          <Link
            component="button"
            onClick={() => window.open(`${basename}/openSource`, '_blank')}
            underline="always"
            sx={{ fontSize: 13, color: theme.palette.text.primary, textDecorationColor: theme.palette.text.primary, cursor: 'pointer' }}
          >
            <FormattedMessage id="aboutOpenSourceLicenses" defaultMessage="Open Source Licenses" />
          </Link>
        </Stack>

        <Typography color="text.secondary" sx={{ mb: 3, display: 'block', fontSize: 13 }}>
          <FormattedMessage id="aboutCopyright" defaultMessage="© {year} NETGEAR®" values={{ year: new Date().getFullYear() }} />
        </Typography>

        <Button variant="outlined" onClick={onClose} sx={{ minWidth: 100 }}>
          <FormattedMessage id="close" defaultMessage="Close" />
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default AboutDialog;
